import { InjectionToken } from '@angular/core';

export type ValidationMessages = Record<string, string>[];

export const VALIDATION_MESSAGES = new InjectionToken<ValidationMessages>(
  'VALIDATION_MESSAGES'
);
